import { useRef } from "react";
import useOnScreen from "./useOnScreen";

export default function Animate(props) {
    const ref = useRef();
    const isVisible = useOnScreen(ref);

    return <div ref={ref} animate={props.animate} className={`${isVisible ? 'show' : ''}`}>{props.children}</div>
}